// extracted by css-extract-rspack-plugin
module.exports =  {"nonGrid":"ZJdIG","cards":"Q_ro7","cardbtmspacing":"Wq8ew","EtimesWidget":"Ewqp2","onebyoneCard":"OXhAM","content":"fMGWu","titlefont":"so6lm"};